import TextInput from '../components/ui-components/TextInput'

export default function Explore() {
  return (
    <div className='h-full w-full flex flex-col items-center justify-center bg-[#EBF2F2]'>
      <div className='font-[700] text-[24px] pb-[24px] underline text-[#232323]'>Explore Mutual Fund</div>
      <TextInput />
    </div>
  )
}
